
import * as constants from "../../assets/constants";
import {baseApi} from "../BaseApi";


class TrademarksApi extends baseApi {

    getList = async () => {
        return await this.get('?app=trademarks&act=getList')
    }

    save = async (data) => {
        return await this.post('?app=trademarks&act=save', {data: JSON.stringify(data)})
    }

}

export default new TrademarksApi(constants.DEBUG?constants.base_url_stage:constants.base_url_prod);

